<template>
  <div class="default-page default-page-center">
    <form @submit.prevent="tryLogin" class="login-form">
      <div class="login-form-icon text-center text-muted mb-4">
        <i class="bi bi-lock-fill"></i>
      </div>
      <div class="alert alert-danger mb-4" role="alert" v-if="errs.length" v-html="errs.join('<br>')"></div>
      <div class="form-floating mb-4">
        <input type="text" class="form-control" id="floatingLogin" placeholder="ФИО или логин" v-model="login_or_name">
        <label for="floatingEmail">Логин</label>
      </div>
      <div class="form-floating mb-4">
        <input type="password" class="form-control" id="floatingPwd" placeholder="Пароль" v-model="password">
        <label for="floatingPwd">Пароль</label>
      </div>
      <div class="text-center pt-3">
        <button type="submit" class="btn btn-primary btn-lg btn-min-width rounded-pill" :disabled="processing">
          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" v-if="processing"></span>
          Войти
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { UserModel } from "@/models/UserModel";

export default {
  name: 'LoginPage',
  data() {
    return {
      errs: [],
      login_or_name: '',
      password : '',
      processing: false,
    }
  },
  methods: {
    async tryLogin() {
      try {
        this.processing = true;
        await UserModel.tryLogin(this.login_or_name, this.password);
        return this.$router.push('/');
      }
      catch (e) {
        this.errs = [e];
      }
      finally {
        this.processing = false;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .login-form {
    max-width: 400px;
    margin: auto;

    &-icon {
      font-size: 50px;
      opacity: 0.33;
    }
  }
</style>